import { TOTAL_VENIT_LUNAR_REALIZAT } from '../../components/EntryTable';
import { IEntry } from '../interfaces/entry.interface';
import { IRequest } from '../interfaces/request.interface';
import { TEST_ENTRIES } from './test-entries';
import htmlToPdfmake from 'html-to-pdfmake';
export const DEFAULT_DATA: PDFStaticBuilderProps = {
  header: {
    image: 'https://i.postimg.cc/MZh99Msy/logo-placeholder.png',
    rightText: 'NR                2024',
  },
  footer: ['XXXXXXXXXXX jud XXXXXX; Romania', 'Phone: XXXXXXXXX; Fax: XXXXXXXXX', 'XXXXXXX.com'],
  settings: {
    empty_months: 0,
  },
  first_page: {
    client_information: ['Emitent: XXXXXXXXX', 'Adresa: XXXXXXXXXX', 'Telefon XXXXXXXXX'],
    title: 'ADEVERINȚĂ',
    paragraphs: [
      {
        text: `Se adeverește prin prezenta că doamna/domnul {name}, născută/născut la data de ______________ în localitatea _______________, județul _______________, având C.N.P. {cnp}, a fost angajată/angajat la*) XXXXXXXXXXXXXXXXXXXXXX, în perioadele:  
        În perioada de la {start_date} pana la {end_date}, având meseria/funția de ________________, a beneficiat de următoarele venituri brute realizate, plătite din fondul de salarii, asupra cărora s-a datorat, potrivit legii, contribuția de asigurări sociale de stat:`,
        alignment: 'left',
      },
    ],
  },
  after_tables: [
    {
      text: `OBSERVAȚII:
    Menționăm faptul că extragerea datelor pentru întocmirea prezentei adeverințe a fost realizată de către XXXXXXXXXXXXX conform Contract Prestări Servicii nr. _________________ _________, operator economic autorizat de Arhivele Naționale pentru prestarea serviciilor arhivistice conform autorizației nr. XXXXXXXXXX`,
      alignment: 'left',
    },
    {
      text: 'Prezenta adeverință s-a întocmit în conformitate cu prevederile art. 139 alin.(2) și modelului prevăzut în Anexa nr. 6 din Legea nr. 360/2023 privind sistemul public de pensii, la cererea dlui {name}, emisă la data de __________________, înregistrată la XXXXXXXXXXXXXXXXXXX sub nr. _________ /_________ 2024.',
      alignment: 'left',
    },
  ],
  last_page: [
    {
      text: 'Menționăm că prezenta adeverință s-a eliberat în baza statelor de plată aflate în arhiva societății (ale căror copii pot fi puse la dispoziția caselor teritoriale de pensii la solicitarea acestora), cunoscându-se atât prevederile Codului penal, referitoare la falsul în înscrisuri oficiale, cât și prevederile legislației de reglementare a pensiilor din sistemul public, potrivit cărora angajatorul poartă întreaga răspundere pentru valabilitatea și corectitudinea actelor doveditoare utilizate la stabilirea drepturilor de pensie.',
      alignment: 'left',
    },
    {
      text: `Conducătorul unității,
        (numele, prenumele, semnătura și ștampila)`,
      alignment: 'center',
    },
    {
      text: `XXXXX XXXXX`,
      alignment: 'center',
    },
    {
      text: `Întocmit
        (nume, prenume, semnătura)`,
      alignment: 'center',
    },
    {
      text: `PRESTATOR - XXXXXXXXXXXXXX, 
      Înregistrată la Registrul Comerțului XXXXXXXX sub numărul XXXXXXXXXX, C.I.F. XXXXXXXXX 
      Adresa: XXXXXXXXXXX
prin reprezentant legal, XXXXXXXXX`,
      alignment: 'center',
    },
    {
      text: '*) Se completează denumirea angajatorului sau, după caz, eventualele denumiri anterioare. În cazul în care unitatea este deținător legal de arhive, se vor preciza calitatea (continuator al activității, operator economic autorizat să presteze servicii arhivistice etc.) și documentul în baza căruia i-a fost stabilită calitatea.',
      alignment: 'left',
    },
  ],
};

export interface PDFStaticBuilderProps {
  header: {
    image: string;
    rightText: string;
  };
  footer: any[];
  settings: {
    empty_months: number;
  };
  first_page: {
    client_information: any[];
    title: string;
    paragraphs: Paragraph[];
  };
  after_tables: Paragraph[];
  last_page: Paragraph[];
}

export interface Paragraph {
  text: string;
  alignment: 'left' | 'center' | 'right';
  type?: 'html' | 'text';
}

const request: Partial<IRequest> & {
  client_name: string;
  company_name: string;
  birthdate: string;
} = {
  name: 'Ion Popescu',
  cnp: '123456789',
  start_date: '01.01.1999',
  end_date: '31.12.2000',
  details: 'Observatii',
  client_name: 'Clientul Y',
  company_name: 'Compania X',
  job_titles: 'Programator, Sudor, Taximetrist',
  working_periods: '01.01.1999 - 31.12.2000',
  birthplace: 'Tecuci, judetul Galati',
  alias: 'Stanciu',
  birthdate: '24.12.2020',
};

const tables = (empty_months: number) => {
  const years = Array.from(new Set(TEST_ENTRIES.map((el) => el.year))).sort();
  // Step 1: Group the objects by year using a Map
  const groupedByYear = TEST_ENTRIES.reduce((acc, curr) => {
    const { year } = curr;
    if (!acc.has(year)) {
      acc.set(year, []);
    }
    acc.get(year).push(curr);
    return acc;
  }, new Map());

  // Step 2: Create an array of 13 properties for each key
  const result: any = {};

  groupedByYear.forEach((entries: IEntry[], year) => {
    const yearData: any = {};

    entries.forEach((entry) => {
      const { month, properties } = entry;

      if (Array.isArray(properties)) {
        properties.forEach(({ key, value }) => {
          if (!yearData[key]) {
            yearData[key] = Array.from({ length: 13 }, (_, index) => ({
              text: index === 0 ? key : empty_months,
              style:
                index === 0
                  ? key === TOTAL_VENIT_LUNAR_REALIZAT
                    ? 'tableLeftBold'
                    : 'tableLeft'
                  : 'tableCell',
            }));
          }
          yearData[key][month] = { text: value || '0', style: 'tableCell' };
        });
      }
    });

    result[year] = Object.values(yearData);
  });

  return { years, result };
};

export const PDFStaticBuilder = (config: PDFStaticBuilderProps = DEFAULT_DATA) => {
  const { empty_months } = config.settings || { empty_months: 0 };
  const { years, result } = tables(empty_months);
  const hasHeader = config.header.image !== '' && config.header.rightText !== '';

  const configCopy = structuredClone(config);

  if (configCopy.header.rightText) {
    configCopy.header.rightText = configCopy.header.rightText?.replace(
      /\{([^}]+)\}/g,
      (match, key) => request[key] || match,
    );
  }

  if (configCopy.footer.length) {
    configCopy.footer = configCopy.footer.map((el: string) => {
      return el.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match);
    });
  }

  if (configCopy.first_page.client_information.length) {
    configCopy.first_page.client_information = configCopy.first_page.client_information.map(
      (el: string) => {
        return htmlToPdfmake(el.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match));
      },
    );
  }

  if (configCopy.first_page.title) {
    configCopy.first_page.title = configCopy.first_page.title.replace(
      /\{([^}]+)\}/g,
      (match, key) => request[key] || match,
    );
  }

  if (configCopy.first_page.paragraphs.length) {
    configCopy.first_page.paragraphs = configCopy.first_page.paragraphs.map((el: Paragraph) => {
      return {
        text:
          el.type === 'html'
            ? htmlToPdfmake(el.text.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match))
            : el.text.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match),
        alignment: el.alignment,
      };
    });
  }

  if (configCopy.after_tables.length) {
    configCopy.after_tables = configCopy.after_tables.map((el: Paragraph) => {
      return {
        text:
          el.type === 'html'
            ? htmlToPdfmake(el.text.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match))
            : el.text.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match),
        alignment: el.alignment,
      };
    });
  }

  if (configCopy.last_page.length) {
    configCopy.last_page = configCopy.last_page.map((el: Paragraph) => {
      return {
        text: el.text.replace(/\{([^}]+)\}/g, (match, key) => request[key] || match),
        alignment: el.alignment,
      };
    });
  }

  const dd = {
    defaultStyle: {
      font: 'Roboto',
    },
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [40, hasHeader ? 80 : 40, 40, configCopy.footer.length * 8 + 50],
    images: {
      logo: configCopy.header.image,
    },
    header: hasHeader && {
      margin: [40, 40, 40, 40],
      columns: [
        configCopy.header.image && {
          image: 'logo',
          width: 100,
        },
        {
          width: '*',
          text: '',
        },
        {
          alignment: 'right',
          text: configCopy.header.rightText || '',
          style: 'p',
        },
      ],
    },
    footer: function (currentPage, totalPages) {
      return [
        {
          margin: [0, 10, 0, 0],
          text: '',
        },
        ...configCopy.footer.map((el) => {
          return {
            margin: [0, 1, 0, 0],
            text: el,
            style: 'footerText',
            alignment: 'center',
          };
        }),
        {
          margin: [0, 2, 0, 0],
          text: `${currentPage}/${totalPages}`,
          style: 'footerPages',
          alignment: 'center',
        },
      ];
    },
    content: [
      {
        stack: [
          ...configCopy.first_page.client_information.map((el) => {
            return el;
          }),
        ],
        style: { fontSize: '10' },
        margin: [0, 0, 0, 10],
      },
      {
        text: configCopy.first_page.title || '',
        alignment: 'center',
        style: { fontSize: 10, bold: true },
      },
      ...configCopy.first_page.paragraphs.map((el) => {
        return {
          text: el.text,
          style: ['extraMargin', el.alignment],
          preserveLeadingSpaces: true,
        };
      }),
      [...years].map((year) => {
        return [
          {
            table: {
              headerRows: 2,
              dontBreakRows: true,
              keepWithHeaderRows: true,
              widths: [100, 45, 45, 40, 40, 35, 45, 35, 50, 55, 50, 50, 50],
              body: [
                [
                  {
                    text: '',
                    colSpan: 1,
                    style: 'tableCell',
                    alignment: 'center',
                  },
                  {
                    text: `ANUL ${year}`,
                    style: 'tableCell',
                    alignment: 'left',
                    colSpan: 12,
                    bold: true,
                  },
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                ],
                [
                  { text: '' },
                  { text: 'Ianuarie', style: 'tableHead' },
                  { text: 'Februarie', style: 'tableHead' },
                  { text: 'Martie', style: 'tableHead' },
                  { text: 'Aprilie', style: 'tableHead' },
                  { text: 'Mai', style: 'tableHead' },
                  { text: 'Iunie', style: 'tableHead' },
                  { text: 'Iulie', style: 'tableHead' },
                  { text: 'August', style: 'tableHead' },
                  { text: 'Septembrie', style: 'tableHead' },
                  { text: 'Octombrie', style: 'tableHead' },
                  { text: 'Noiembrie', style: 'tableHead' },
                  { text: 'Decembrie', style: 'tableHead' },
                ],
                ...result[year],
              ],
            },
          },
          {
            text: '',
            style: 'extraMargin',
          },
        ];
      }),
      {
        text: '',
        style: 'extraMargin',
      },
      ...configCopy.after_tables.map((el) => {
        return {
          text: el.text,
          style: [el.alignment],
          preserveLeadingSpaces: true,
        };
      }),
      {
        pageBreak: 'before',
        text: '',
        style: 'p',
      },
      ...configCopy.last_page.map((el) => {
        return {
          text: el.text,
          style: [el.alignment],
          preserveLeadingSpaces: true,
        };
      }),
      {
        text: ``,
        margin: [0, 30],
      },
    ],
    styles: {
      p: {
        margin: [0, 5],
        fontSize: 10,
      },
      extraMargin: {
        margin: [0, 10],
      },
      center: {
        margin: [0, 5],
        fontSize: 10,
        alignment: 'center',
      },
      right: {
        margin: [0, 5],
        fontSize: 10,
        alignment: 'right',
      },
      left: {
        margin: [0, 5],
        fontSize: 10,
        alignment: 'justify',
      },
      tableCell: {
        font: 'Roboto',
        fontSize: 8,
        alignment: 'right',
        margin: [0, 5, 0, 0],
      },
      tableHead: {
        font: 'Roboto',
        fontSize: 8,
        bold: true,
        alignment: 'center',
        margin: [2, 2],
      },
      tableLeft: {
        font: 'Roboto',
        fontSize: 8,
        alignment: 'left',
        margin: [0, 4, 0, 0],
      },
      tableLeftBold: {
        font: 'Roboto',
        fontSize: 8,
        alignment: 'left',
        margin: [0, 4, 0, 0],
        bold: true,
      },
      footerText: {
        fontSize: 8,
        color: 'gray',
      },
      footerPages: {
        fontSize: 8,
      },
      footerSite: {
        fontSize: 8,
        color: 'blue',
        decoration: 'underline',
      },
    },
  };

  return dd;
};
